import React from 'react';
import TextInput from 'components/inputs/TextInput';
import TextAreaInput from 'components/inputs/TextAreaInput';
import FormItem from 'components/common/FormItem';
import ScheduledInvoiceForm from 'components/forms/ScheduledInvoiceForm';
import ChooseEmailTemplateButton from 'components/common/ChooseEmailTemplateButton';

class SendStep extends React.PureComponent {
  onTemplateSelected = template => {
    this.props.onChange({
      clientEmailMessage: template.body,
      clientEmailSubject: template.subject,
    });
  };

  render() {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div
          style={{
            height: 270,
            width: 400,
            maxWidth: '100%',
            textAlign: 'left',
          }}
        >
          <FormItem>
            <label>Client Email</label>
            <TextInput
              onChange={clientEmail => this.props.onChange({ clientEmail })}
              value={this.props.invoice.clientEmail || ''}
            />
          </FormItem>
          <FormItem>
            <label>Email Subject</label>
            <TextInput
              onChange={clientEmailSubject => this.props.onChange({ clientEmailSubject })}
              value={this.props.invoice.clientEmailSubject || ''}
            />
          </FormItem>
          <FormItem>
            <label>Email Message</label>
            <TextAreaInput
              onChange={e => this.props.onChange({
                clientEmailMessage: e.target.value,
              })
              }
              placeholder="Thank you for yor business. Please review the attached invoice."
              value={this.props.invoice.clientEmailMessage}
            />
          </FormItem>
          <ChooseEmailTemplateButton onTemplateSelected={this.onTemplateSelected} />
          <ScheduledInvoiceForm
            invoiceId={this.props.invoice._id}
            onChange={value => this.props.onChange(value)}
            scheduleInvoice={this.props.invoice.scheduleInvoice}
            scheduledInvoiceDate={this.props.invoice.scheduledInvoiceDate}
          />
        </div>
      </div>
    );
  }
}

export default SendStep;



// WEBPACK FOOTER //
// ./src/routes/invoice-create/SendStep/index.js